<template>
  <div class="bg-primary bg-opacity-80 rounded-md px-4 py-4 mb-5 relative">
    <slot />
  </div>
</template>
